export default __webpack_public_path__ + "static/8521-f26367d7aaee3f69258ab50976874719.jpg";